
<app-custom-index></app-custom-index>
<div class="row ">
  <div class="col-lg-12">
    <div class="col-lg-12">
      <div class="card">
        <!-- Card header -->
        <div class="card-header border-0">
          <div class="row">
            <h3 class="mb-0">Certificate HTML Files</h3>
          </div>
        </div>
        <!-- Light table -->
        <div class="table-responsive">
          <table class="table align-items-center table-flush table-hover">
            <!-- <thead>
                    <tr>
                        <th colspan="4" class="text-right"> Total : </th><th class="text-right">₦{{this.util.numberWithCommas(sumTotal)}}</th>
                    </tr>
                </thead> -->
            <thead class="thead-light">
              <tr>
                <th> File Name</th>
                <th> Url</th>
                <th> In Use</th>
                <th> Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of customCertificateFiles">
                <td>{{item.fileName}}</td>
                <td> {{ item.url}}</td>
                <td class="text-uppercase"> {{ item.inUse}}</td>
                <td>
                  <div class="menu-nav">
                    <div class="dropdown-container" tabindex="-1">
                      <div class="three-dots"></div>
                      <div class="dropdown">
                        <a>
                          <div (click)="testCertificate(item.id)"><i class="far fa-file-pdf handCusor text-primary-darker mr-2"></i>
                            Test</div>
                        </a>
                        <hr>
                        <a>
                          <div (click)="popFileDelete(item)"><i class="fas fa-trash handCusor text-danger mr-2"></i>
                            Delete</div>
                        </a>
                        <hr>
                        <a>
                          <div (click)="downloadFile(item.url)"><i
                              class="fas fa-download mr-2 handCusor text-primary"></i> Download
                          </div>
                        </a>
                        <hr>
                        <a>
                          <div (click)="markCertificateFileInUse(item)"><i
                              class="fas fa-check-double mr-2 handCusor"></i> Mark InUse</div>
                        </a>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <p *ngIf="customCertificateFiles.length<=0" class="text-center">No File Available</p>

        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" #uploadCertificate id="uploadCertificate" aria-hidden="true" aria-labelledby="uploadCertificate"
  role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Upload Certificate Html</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form #uploadform="ngForm" name="uploadform" (submit)="uploadCertificateFile()">
          <div class="d-flex justify-content-center align-content-center">
            <div class="mb-3">
              <label for="formFile" class="form-label">Certificate HTML File</label>
              <input class="form-control" type="file" id="formFile" required accept=".html"
                [(ngModel)]="customCertificate.File" [ngModelOptions]="{standalone: true}"
                (change)="onFileSelected($event)">
            </div>

            <!-- <div class="col-6">
                <div class="mb-3">
                  <label class="form-label">File Name</label>
                  <input type="text" class="form-control" [(ngModel)]="customCss.FileName"
                    [ngModelOptions]="{standalone: true}">
                </div>
              </div> -->
          </div>
          <div class="d-flex justify-content-around flex-wrap gap-1.5 mt-5">
            <button type="submit" class="btn m-0">Upload</button>
            <button type="button" class="btn btn--warning m-0" data-dismiss="modal">Close</button>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="deleteFile" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Delete File</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <p class="text-center pb-2">Are you sure you want to delete this File? <b>{{fileToDelete.fileName}}</b></p>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="submit" class="btn btn--danger m-0" (click)="deleteCertificateFile()">Delete</button>
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>
